import { Add } from '@mui/icons-material';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Button, CircularProgress, Stack, Tab, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { setAutocolonSearchValue, setGeofenceSearchValue, setGroupSearchValue, setGroupSelectedItem } from 'app/actions/transport';
import { IconButton, InputSearch, Scrollbar } from 'app/components';
import { TransportGroupDialog, TransportGroupForm, TransportGroupList, TransportGroupTransportList } from 'app/pages/TransportGroup';
import DivisionAutocolonEditBlock from 'app/pages/TransportGroup/DivisionAutocolon/DivisionAutocolonEditBlock';
import Divisions from 'app/pages/TransportGroup/DivisionAutocolon/Divisions';
import AutocolonDialog from 'app/pages/TransportGroup/DivisionAutocolon/TransportGroupDialog';
import GeofenceList from 'app/pages/TransportGroup/Geofence/GeofenceList';
import { geofenceGroupItemsMapSelector } from 'app/selectors/map';
import {
  autocolonSelectedItemTransportSelector,
  groupItemsSelector,
  groupSearchValueSelector,
  groupSelectedItemSelector,
} from 'app/selectors/transport';
import { useAsyncAction } from 'app/services';
import { geofenceGroupLoad } from 'app/store/map';
import {
  autocolunItemsLoad,
  divisionItemsLoad,
  transportGroupDataLoad,
  transportGroupDelete,
  transportGroupLoad,
  transportGroupTransportSend,
  transportGroupUpdate,
  updateAutocolonsList,
} from 'app/store/transport';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const TransportGroup = () => {
  const formRef = useRef();
  const dispatch = useDispatch();
  const theme = useTheme();
  const groupItems = useSelector(groupItemsSelector);
  const groupSelectedItem = useSelector(groupSelectedItemSelector);
  const groupSearchValue = useSelector(groupSearchValueSelector);

  const { geofenceSearchValue, autocolonSearchValue, autocolonItems } = useSelector((state) => state.transport);

  const geofenceGroupItems = useSelector(geofenceGroupItemsMapSelector);
  const [tab, setTab] = useState('info');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAutocolonOpen, setDialogAutocolonOpen] = useState(false);
  const [editDivisionAutocolon, setEditDivisionAutocolon] = useState(false);
  const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportGroupLoad);
  const { asyncAction: fetchGroupData, isLoading: isFetchGroupLoading } = useAsyncAction(transportGroupDataLoad);
  const { asyncAction: fetchGeofenceData, isLoading: isFetchGeofenceLoading } = useAsyncAction(geofenceGroupLoad);

  const {
    asyncAction: updateSubmit,
    isLoading: isUpdateLoading,
    isSuccessful: isUpdateSuccessful,
    isError: isUpdateError,
  } = useAsyncAction(transportGroupUpdate, [groupSelectedItem]);
  const {
    isLoading: isDeleteLoading,
    isSuccessful: isDeleteSuccessful,
    isError: isDeleteError,
  } = useAsyncAction(transportGroupDelete, [groupSelectedItem]);
  const {
    asyncAction: sendSubmit,
    isLoading: isSendLoading,
    isSuccessful: isSendSuccessful,
    isError: isSendError,
  } = useAsyncAction(transportGroupTransportSend, [groupSelectedItem]);
  const { asyncAction: fetchDivisionItems, isLoading: isDivisionItems } = useAsyncAction(divisionItemsLoad);
  let {
    asyncAction: fetchUpdateAutocolonsList,
    isLoading: isLoadingAutocolonsList,
    isSuccessful: isSuccessfulAutocolonsList,
    isError: isErrorAutocolonsList,
    setIsLoading: setIsLoadingAutocolonsList,
    setIsError: setIsErrorAutocolonsList,
    setIsSuccessful: setIsSuccessfulAutocolonsList,
  } = useAsyncAction(updateAutocolonsList);
  const { asyncAction: fetchAutocolunItems, isLoading: isAutocolunItems } = useAsyncAction(autocolunItemsLoad);
  const handleDialogOpen = () => {
    setDialogOpen(true);
  };
  const [haveUpdate, setHaveUpdate] = useState(false);
  const handleSaveAutocolonsInfo = async () => {
    setHaveUpdate(false);
    await fetchUpdateAutocolonsList(autocolonItems);
    cleanInfo();
  };
  const handleResetAutocolonsInfo = async () => {
    setHaveUpdate(false);
    await fetchAutocolunItems();
  };
  const cleanInfo = () => {
    setTimeout(() => {
      setIsLoadingAutocolonsList(false);
      setIsErrorAutocolonsList(false);
      setIsSuccessfulAutocolonsList(false);
    }, 3000);
  };
  const handleDialogAutocolonToggle = (item) => {
    setEditDivisionAutocolon(item);
    setDialogAutocolonOpen(!dialogAutocolonOpen);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleTabChange = (event, value) => {
    setTab(value);
  };

  const handleFormClick = () => {
    formRef.current?.handleFormSubmit();
  };

  const handleFormSubmit = (data) => {
    updateSubmit(groupSelectedItem.id, data);
  };

  const handleSearchValue = (value) => dispatch(setGroupSearchValue(value));
  const handleSearchValueGeofence = (value) => dispatch(setGeofenceSearchValue(value));
  const handleSearchValueForAutocolon = (value) => {
    dispatch(setAutocolonSearchValue(value));
  };

  const handleDataSend = () => {
    sendSubmit({
      ids: groupSelectedItem.transportItems.map((item) => item.id).join(','),
    });
  };

  useEffect(() => {
    if (!!groupSelectedItem && !isFetchGroupLoading) {
      fetchGroupData(groupSelectedItem.id);
    }
  }, [groupSelectedItem?.id]);

  useEffect(() => {
    fetchData();
    fetchDivisionItems();
    fetchAutocolunItems();
    fetchGeofenceData();
    return () => dispatch(setGroupSelectedItem(null));
  }, []);

  const autocolonSelectedItem = useSelector(autocolonSelectedItemTransportSelector);

  return (
    <React.Fragment>
      <Stack
        direction='column'
        sx={(theme) => ({
          width: '230px',
          height: '100%',
          zIndex: '1010',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: theme.palette.divider,
        })}>
        {!isDivisionItems && !isAutocolunItems && groupItems.length !== 0 && (
          <React.Fragment>
            <Stack direction='row' alignItems='center' sx={(theme) => ({ padding: theme.spacing(2) })}>
              <InputSearch placeholder='Дивизион-Автоколонна' value={autocolonSearchValue} onChange={handleSearchValueForAutocolon} />
              <IconButton onClick={handleDialogAutocolonToggle} endIcon={<Add />} />
              {dialogAutocolonOpen && (
                <AutocolonDialog
                  open={dialogAutocolonOpen}
                  onClose={handleDialogAutocolonToggle}
                  editDivisionAutocolon={editDivisionAutocolon.name && editDivisionAutocolon}
                />
              )}
            </Stack>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='center'
              sx={{
                flex: '1 1 auto',
                overflow: 'hidden',
              }}>
              <Divisions />
            </Stack>
          </React.Fragment>
        )}
        {!isFetchLoading && groupItems.length === 0 && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <Typography align='center' variant='body1' component='div'>
              Здесь пока ничего нет
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='div'>
              В этом списке будут отображаться группы геозон
            </Typography>
          </Stack>
        )}
        {isFetchLoading && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <CircularProgress size={24} />
          </Stack>
        )}
      </Stack>
      <Stack
        direction='column'
        sx={(theme) => ({
          width: '230px',
          height: '100%',
          zIndex: '1010',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: theme.palette.divider,
        })}>
        {!isFetchLoading && groupItems.length !== 0 && (
          <React.Fragment>
            <Stack direction='row' alignItems='center' sx={(theme) => ({ padding: theme.spacing(2) })}>
              <InputSearch placeholder='Название группы транспорта' value={groupSearchValue} onChange={handleSearchValue} />
              <IconButton onClick={handleDialogOpen} endIcon={<Add />} />
              <TransportGroupDialog open={dialogOpen} onClose={handleDialogClose} />
            </Stack>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='center'
              sx={{
                flex: '1 1 auto',
                overflow: 'hidden',
              }}>
              <TransportGroupList setHaveUpdate={setHaveUpdate} />
            </Stack>
          </React.Fragment>
        )}

        {!isFetchLoading && groupItems.length === 0 && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <Typography align='center' variant='body1' component='div'>
              Здесь пока ничего нет
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='div'>
              В этом списке будут отображаться группы геозон
            </Typography>
          </Stack>
        )}
        {isFetchLoading && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <CircularProgress size={24} />
          </Stack>
        )}
      </Stack>

      <Stack
        direction='column'
        sx={(theme) => ({
          width: '230px',
          height: '100%',
          zIndex: '1010',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: theme.palette.divider,
        })}>
        {!isFetchGeofenceLoading && geofenceGroupItems.length !== 0 && (
          <React.Fragment>
            <Stack
              direction='row'
              alignItems='center'
              sx={(theme) => ({
                padding: theme.spacing(2),
                '& .MuiInputBase-adornedEnd': {
                  padding: '8px',
                },
              })}>
              <InputSearch placeholder='Название геозоны' value={geofenceSearchValue} onChange={handleSearchValueGeofence} />
            </Stack>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='center'
              sx={{
                flex: '1 1 auto',
                overflow: 'hidden',
              }}>
              <GeofenceList setHaveUpdate={setHaveUpdate} />
            </Stack>
          </React.Fragment>
        )}

        {!isFetchGeofenceLoading && geofenceGroupItems.length === 0 && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <Typography align='center' variant='body1' component='div'>
              Здесь пока ничего нет
            </Typography>
            <Typography align='center' color='text.secondary' variant='caption' component='div'>
              В этом списке будут отображаться группы геозон
            </Typography>
          </Stack>
        )}
        {isFetchGeofenceLoading && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={{
              width: '100%',
              height: '100%',
            }}>
            <CircularProgress size={24} />
          </Stack>
        )}
      </Stack>

      <Stack
        direction='column'
        sx={{
          height: '100%',
          flex: '1 1 auto',
          '.simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          },
        }}>
        <Stack
          direction='row'
          sx={{
            height: '50px',
            marginBottom: '10px',
            padding: theme.spacing(isLoadingAutocolonsList || isSuccessfulAutocolonsList || isErrorAutocolonsList ? 0 : 2, 5),
            bgcolor: haveUpdate ? '#FFFFFF' : 'inherit',
            width: '475px',
            flexShrink: 0,
          }}>
          {haveUpdate && (
            <>
              <Button variant='contained' color='error' onClick={handleResetAutocolonsInfo}>
                Отменить все изменения
              </Button>
              <Button
                variant='contained'
                onClick={handleSaveAutocolonsInfo}
                sx={{
                  marginLeft: '16px',
                }}>
                Сохранить изменения
              </Button>
            </>
          )}

          {isLoadingAutocolonsList && (
            <Alert severity='info' sx={{ width: '100%' }}>
              Данные сохраняются.
            </Alert>
          )}
          {isErrorAutocolonsList && (
            <Alert severity='error' sx={{ width: '100%' }}>
              Произошла ошибка при обвновлении. Попробуйте снова или обратитесь в техническую поддержку.
            </Alert>
          )}
          {isSuccessfulAutocolonsList && (
            <Alert severity='success' sx={{ width: '100%' }}>
              Данные успешно изменены.
            </Alert>
          )}
        </Stack>
        {!!autocolonSelectedItem && !groupSelectedItem && <DivisionAutocolonEditBlock />}
        {groupSelectedItem && (
          <Scrollbar
            sx={{
              height: 'calc(100% - 70px)',
            }}>
            <Stack
              direction='column'
              alignItems='center'
              sx={(theme) => ({
                maxWidth: '540px',
                margin: '0 auto',
                width: '100%',
                height: ['list', 'checklist'].includes(tab) ? '100%' : 'auto',
                padding: theme.spacing(2),
              })}>
              <Stack
                direction='column'
                alignItems='left'
                sx={(theme) => ({
                  width: '100%',
                  height: ['list', 'checklist'].includes(tab) ? '100%' : 'auto',
                  position: 'relative',
                  padding: theme.spacing(0),
                  border: '1px solid',
                  borderRadius: theme.shape.borderRadius,
                  borderColor: theme.palette.divider,
                  bgcolor: 'background.paper',
                  '.MuiTabPanel-root': {
                    width: '100%',
                    padding: theme.spacing(2),
                  },
                  form: {
                    width: '100%',
                  },
                })}>
                <TabContext value={tab}>
                  <TabList
                    onChange={handleTabChange}
                    TabIndicatorProps={{
                      children: <span />,
                    }}
                    sx={(theme) => ({
                      width: '100%',
                      minHeight: '44px',
                      borderBottom: '1px solid',
                      borderColor: theme.palette.divider,
                      '.MuiTab-root': {
                        fontSize: '12px',
                        minHeight: '44px',
                        padding: theme.spacing(2),
                        '&.Mui-selected': {
                          color: 'inherit',
                        },
                      },
                      '.MuiTabs-indicator': {
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: 'transparent',
                      },
                      '.MuiTabs-indicator span': {
                        width: 'calc(100% - ' + theme.spacing(4) + ')',
                        bgcolor: theme.palette.primary.main,
                        borderRadius: theme.shape.borderRadius,
                      },
                    })}>
                    <Tab value='info' label='Информация' disableRipple />
                    <Tab value='list' label='Транспортные средства' disableRipple />
                    {/* <Tab
                                            value="checklist"
                                            label="Чеклисты"
                                            disableRipple
                                        /> */}
                  </TabList>
                  <TabPanel value='info'>
                    <Stack
                      direction='column'
                      sx={(theme) => ({
                        width: '100%',
                        position: 'relative',
                        paddingBottom: theme.spacing(1),
                        form: {
                          width: '100%',
                        },
                      })}>
                      <TransportGroupForm ref={formRef} defaultValues={groupSelectedItem} onSubmit={handleFormSubmit} />
                      <Stack
                        direction='row'
                        justifyContent='flex-end'
                        sx={(theme) => ({
                          width: '100%',
                          '.MuiAlert-root': {
                            width: '100%',
                            marginTop: theme.spacing(2),
                            borderRadius: theme.shape.borderRadius,
                          },
                        })}>
                        {!isUpdateLoading && isUpdateError && (
                          <Alert severity='error'>
                            Произошла ошибка при изменении данных. Попробуйте снова или обратитесь в техническую поддержку.
                          </Alert>
                        )}
                        {!isUpdateLoading && isUpdateSuccessful && <Alert severity='success'>Данные успешно изменены.</Alert>}
                      </Stack>
                      <Stack
                        direction='row'
                        justifyContent='flex-end'
                        sx={(theme) => ({
                          width: '100%',
                          paddingTop: theme.spacing(3),
                        })}>
                        <LoadingButton variant='contained' loading={isUpdateLoading} onClick={handleFormClick} disableElevation>
                          Сохранить изменения
                        </LoadingButton>
                      </Stack>
                    </Stack>
                  </TabPanel>
                  <TabPanel value='list' style={{ height: '100%', padding: '0' }}>
                    {!isFetchGroupLoading && groupSelectedItem.transports.length !== 0 && (
                      <Stack
                        direction='row'
                        flexDirection='column'
                        sx={{
                          height: '100%',
                        }}>
                        <Stack
                          direction='row'
                          flexDirection='column'
                          sx={{
                            flex: '1 1 auto',
                          }}>
                          <TransportGroupTransportList />
                        </Stack>
                        <Stack
                          direction='column'
                          sx={(theme) => ({
                            width: '100%',
                            padding: theme.spacing(2),
                          })}>
                          <Stack
                            direction='row'
                            justifyContent='flex-start'
                            sx={(theme) => ({
                              width: '100%',
                              '.MuiAlert-root': {
                                width: '100%',
                                marginBottom: theme.spacing(2),
                                borderRadius: theme.shape.borderRadius,
                              },
                            })}>
                            {!isSendLoading && isSendError && (
                              <Alert severity='error'>
                                Произошла ошибка при отправке данных. Попробуйте снова или обратитесь в техническую поддержку.
                              </Alert>
                            )}
                            {!isSendLoading && isSendSuccessful && <Alert severity='success'>Данные успешно отправлены.</Alert>}
                          </Stack>
                          <Stack direction='row' justifyContent='flex-end'>
                            <LoadingButton variant='contained' loading={isSendLoading} onClick={handleDataSend} disableElevation>
                              Отправить данные в Okdesk
                            </LoadingButton>
                          </Stack>
                        </Stack>
                      </Stack>
                    )}
                    {!isFetchGroupLoading && groupSelectedItem.transports.length === 0 && (
                      <Stack
                        direction='column'
                        alignItems='center'
                        justifyContent='center'
                        sx={(theme) => ({
                          width: '100%',
                          height: '100%',
                          padding: theme.spacing(2),
                        })}>
                        <Typography align='center' variant='body1' component='div'>
                          Здесь пока ничего нет
                        </Typography>
                        <Typography align='center' color='text.secondary' variant='caption' component='div'>
                          В этом списке будут отображаться транспортные средства группы.
                        </Typography>
                      </Stack>
                    )}
                    {isFetchGroupLoading && (
                      <Stack
                        direction='column'
                        alignItems='center'
                        justifyContent='center'
                        sx={(theme) => ({
                          width: '100%',
                          height: '100%',
                          padding: theme.spacing(2),
                        })}>
                        <CircularProgress size={24} />
                      </Stack>
                    )}
                  </TabPanel>
                  {/* <TabPanel
                                        value="checklist"
                                        style={{ height: '100%', padding: '0' }}
                                    >
                                        {!isFetchGroupLoading &&
                                            groupSelectedItem.checklists
                                                .length !== 0 && (
                                                <Stack
                                                    direction="row"
                                                    flexDirection="column"
                                                    sx={{
                                                        height: '100%',
                                                    }}
                                                >
                                                    <Stack
                                                        direction="row"
                                                        flexDirection="column"
                                                        sx={{
                                                            flex: '1 1 auto',
                                                            height: '100%',
                                                        }}
                                                    >
                                                        <TransportGroupCheckList />
                                                        <TransportGroupCheckListDialog
                                                            open={
                                                                dialogCheckListDetailOpen
                                                            }
                                                            onClose={
                                                                handleDialogCheckListDetailClose
                                                            }
                                                            defaultValues={
                                                                checkListSelectedItem
                                                            }
                                                        />
                                                    </Stack>
                                                    <Stack
                                                        direction="column"
                                                        sx={(theme) => ({
                                                            width: '100%',
                                                            padding:
                                                                theme.spacing(
                                                                    2
                                                                ),
                                                        })}
                                                    >
                                                        <Stack
                                                            direction="column"
                                                            justifyContent="flex-start"
                                                            sx={(theme) => ({
                                                                width: '100%',
                                                                '.MuiAlert-root':
                                                                    {
                                                                        width: '100%',
                                                                        marginBottom:
                                                                            theme.spacing(
                                                                                2
                                                                            ),
                                                                        borderRadius:
                                                                            theme
                                                                                .shape
                                                                                .borderRadius,
                                                                    },
                                                            })}
                                                        >
                                                            {!isSendLoading &&
                                                                isSendError && (
                                                                    <Alert severity="error">
                                                                        Произошла
                                                                        ошибка
                                                                        при
                                                                        отправке
                                                                        данных.
                                                                        Попробуйте
                                                                        снова
                                                                        или
                                                                        обратитесь
                                                                        в
                                                                        техническую
                                                                        поддержку.
                                                                    </Alert>
                                                                )}
                                                            {!isSendLoading &&
                                                                isSendSuccessful && (
                                                                    <Alert severity="success">
                                                                        Данные
                                                                        успешно
                                                                        отправлены.
                                                                    </Alert>
                                                                )}
                                                        </Stack>
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="flex-end"
                                                        >
                                                            <TransportGroupCheckListDialog
                                                                open={
                                                                    dialogChecklistOpen
                                                                }
                                                                onClose={
                                                                    handleDialogChecklistClose
                                                                }
                                                            />
                                                            <LoadingButton
                                                                variant="contained"
                                                                onClick={
                                                                    handleDialogChecklistOpen
                                                                }
                                                                disableElevation
                                                            >
                                                                Добавить
                                                            </LoadingButton>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            )}
                                        {!isFetchGroupLoading &&
                                            groupSelectedItem.checklists
                                                .length === 0 && (
                                                <Stack
                                                    direction="column"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={(theme) => ({
                                                        width: '100%',
                                                        height: '100%',
                                                        padding:
                                                            theme.spacing(2),
                                                    })}
                                                >
                                                    <Typography
                                                        align="center"
                                                        variant="body1"
                                                        component="div"
                                                    >
                                                        Здесь пока ничего нет
                                                    </Typography>
                                                    <Typography
                                                        align="center"
                                                        color="text.secondary"
                                                        variant="caption"
                                                        component="div"
                                                    >
                                                        В этом списке будут
                                                        отображаться чеклисты.
                                                    </Typography>
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="flex-end"
                                                        sx={{ marginTop: 2 }}
                                                    >
                                                        <TransportGroupCheckListDialog
                                                            open={
                                                                dialogChecklistFirstOpen
                                                            }
                                                            onClose={
                                                                handleDialogChecklistFirstClose
                                                            }
                                                        />
                                                        <LoadingButton
                                                            variant="contained"
                                                            onClick={
                                                                handleDialogChecklistFirstOpen
                                                            }
                                                            disableElevation
                                                        >
                                                            Добавить
                                                        </LoadingButton>
                                                    </Stack>
                                                </Stack>
                                            )}
                                        {isFetchGroupLoading && (
                                            <Stack
                                                direction="column"
                                                alignItems="center"
                                                justifyContent="center"
                                                sx={(theme) => ({
                                                    width: '100%',
                                                    height: '100%',
                                                    padding: theme.spacing(2),
                                                })}
                                            >
                                                <CircularProgress size={24} />
                                            </Stack>
                                        )}
                                    </TabPanel> */}
                </TabContext>
              </Stack>
              {tab === 'info' && (
                <Stack
                  direction='column'
                  alignItems='center'
                  sx={(theme) => ({
                    width: '100%',
                    display: 'none',
                    position: 'relative',
                    marginTop: theme.spacing(3),
                    padding: theme.spacing(2),
                    border: '1px solid',
                    borderRadius: theme.shape.borderRadius,
                    borderColor: theme.palette.divider,
                    bgcolor: 'background.paper',
                    '.MuiAlert-root': {
                      marginTop: theme.spacing(0),
                      marginBottom: theme.spacing(3),
                    },
                  })}>
                  <Stack
                    direction='column'
                    sx={(theme) => ({
                      width: '100%',
                      paddingBottom: theme.spacing(3),
                      '.MuiTypography-h6': {
                        fontSize: '15px',
                      },
                      '.MuiTypography-caption': {
                        color: theme.palette.text.secondary,
                      },
                    })}>
                    <Typography variant='h6'>Удалить группу</Typography>
                    <Typography variant='caption'>
                      Можно удалить данную группу транспорта, но это действие необратимо. Весь прикрепленный транспорт будет удален из
                      данной группы. Пожалуйста, будьте уверены, что Вы хотите это сделать.
                    </Typography>
                  </Stack>
                  <Stack
                    direction='row'
                    justifyContent='flex-end'
                    sx={(theme) => ({
                      width: '100%',
                      '.MuiAlert-root': {
                        width: '100%',
                        marginTop: theme.spacing(1),
                        borderRadius: theme.shape.borderRadius,
                      },
                    })}>
                    {!isDeleteLoading && isDeleteError && (
                      <Alert severity='error'>
                        Произошла ошибка при удалении данных. Попробуйте снова или обратитесь в техническую поддержку.
                      </Alert>
                    )}
                    {!isDeleteLoading && isDeleteSuccessful && <Alert severity='success'>Данные успешно удалены.</Alert>}
                  </Stack>
                  <Stack
                    direction='row'
                    justifyContent='flex-end'
                    sx={(theme) => ({
                      width: '100%',
                      paddingTop: theme.spacing(0),
                    })}>
                    <LoadingButton color='error' variant='contained' loading={isDeleteLoading} disableElevation>
                      Удалить группу
                    </LoadingButton>
                  </Stack>
                </Stack>
              )}
            </Stack>
          </Scrollbar>
        )}
        {!groupSelectedItem && !autocolonSelectedItem && (
          <Stack
            direction='column'
            alignItems='center'
            justifyContent='center'
            sx={(theme) => ({
              height: '100%',
              padding: theme.spacing(0, 2),
              '.MuiTypography-root': {
                borderRadius: '20px',
                marginTop: '24px',
                padding: theme.spacing(0.5, 2),
                bgcolor: alpha(theme.palette.grey.main, 0.12),
              },
            })}>
            <Typography align='center' color='text.secondary' variant='caption' component='label'>
              Выберите группу транспорта, автоколонну или дивизион списка
            </Typography>
          </Stack>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default TransportGroup;
